import { render } from "./MpfSettingManage.vue?vue&type=template&id=7462404b"
import script from "./MpfSettingManage.vue?vue&type=script&lang=js"
export * from "./MpfSettingManage.vue?vue&type=script&lang=js"

import "./MpfSettingManage.vue?vue&type=style&index=0&id=7462404b&lang=less"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__